import { svg } from 'lit';

export const infoFilledIcon = svg`
  <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 6C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8H12.01C12.5623 8 13.01 7.55228 13.01 7C13.01 6.44772 12.5623 6 12.01 6H12ZM13 10.5C13 9.94772 12.5523 9.5 12 9.5C11.4477 9.5 11 9.94772 11 10.5V17.5C11 18.0523 11.4477 18.5 12 18.5C12.5523 18.5 13 18.0523 13 17.5V10.5Z" fill="currentColor"/>
  `;
